// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._7\\+qXX {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n\n.XcwPu {\n  cursor: initial;\n}\n\n.Ej-mt {\n  background-color: rgba(2, 136, 209, 0.05);\n}\n\n.\\+l-q4 {\n  margin-left: var(--spacing-xs);\n}\n\n.OnzhG {\n  color: var(--color-font);\n  font-size: var(--schoolinks-font-size-xs);\n  font-family: var(--font-family-body);\n  line-height: 16px;\n  word-break: break-word;\n}\n\n.r7VuZ {\n  color: var(--color-gray-dark);\n  font-family: var(--font-family-body);\n  font-size: var(--schoolinks-font-size-xxs);\n  line-height: 14px;\n  margin-top: 4px;\n}\n\n._8YsDI {\n  color: var(--color-blue-xtra-dark);\n  font-weight: bold;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_7+qXX",
	"initialCursor": "XcwPu",
	"unread": "Ej-mt",
	"content": "+l-q4",
	"paragraph": "OnzhG",
	"created": "r7VuZ",
	"highlight": "_8YsDI"
};
export default ___CSS_LOADER_EXPORT___;
